// Date locale AAAA-MM-JJ — évite le décalage UTC de toISOString()
// (en fuseau UTC+1/+2, minuit local devient la veille en UTC).
export const isoDate = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
